var React = require('react');

function ShoppingCartInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"d":"M8.5 22a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm12 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M1 3h4l3.783 12.294a1 1 0 0 0 .956.706h9.54a1 1 0 0 0 .949-.684l2.333-7A1 1 0 0 0 21.613 7H7","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"square","strokeLinejoin":"round","key":1})]));
}

ShoppingCartInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ShoppingCartInline;

ShoppingCartInline.default = ShoppingCartInline;
